import axios from "axios";

const createApiClient = (baseURL) => {
    const apiClient = axios.create({
        baseURL,
        headers: {
            "Content-Type": "application/json",
        },
    });

    apiClient.interceptors.response.use(
        (response) => {
            if (response.status >= 200 && response.status < 300) {
                return response.data;
            }
            return Promise.reject(response);
        },
        (error) => {
            return handleErrorResponse(error.response);
        },
    );

    const handleErrorResponse = (response) => {
        const resp = response?.data;
        let error;
        if (resp?.message?.error) {
            error = resp.message.error;
        }

        if (resp?.message) {
            error = resp.message;
        }

        if (resp?.errors) {
            error = resp.errors.map((err) => err.message).join(", ");
        }
        return Promise.reject(error);
    };

    const setAuthToken = (token) => {
        if (token) {
            apiClient.defaults.headers.common["Authorization"] =
                `Bearer ${token}`;
        } else {
            delete apiClient.defaults.headers.common["Authorization"];
        }
    };

    return { ...apiClient, setAuthToken };
};

const apiClients = {
    feesAPI: createApiClient(process.env.REACT_APP_FEE_BACKEND_URL),
    templatesAPI: createApiClient(
        process.env.REACT_APP_SIGNATURE_SERVICE_BACKEND_URL,
    ),
};

export default apiClients;
export const setAuthTokens = (token) => {
    Object.values(apiClients).forEach((client) => {
        client.setAuthToken(token);
    });
};
